/**
 * Numeric Input Hook
 * Prevents non-numeric characters from being entered in number inputs
 */
const NumericInputHook = {
  mounted() {
    this.handleKeydown = (e) => {
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (e.keyCode === 65 && e.ctrlKey === true) ||
          (e.keyCode === 67 && e.ctrlKey === true) ||
          (e.keyCode === 86 && e.ctrlKey === true) ||
          (e.keyCode === 88 && e.ctrlKey === true) ||
          // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    };

    this.handleInput = (e) => {
      // Remove any non-numeric characters
      const value = e.target.value;
      const numericValue = value.replace(/[^0-9]/g, '');
      
      if (value !== numericValue) {
        e.target.value = numericValue;
        // Trigger input event to update LiveView
        e.target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };

    this.el.addEventListener('keydown', this.handleKeydown);
    this.el.addEventListener('input', this.handleInput);
  },

  destroyed() {
    this.el.removeEventListener('keydown', this.handleKeydown);
    this.el.removeEventListener('input', this.handleInput);
  }
};

export default NumericInputHook;
